export interface ManualContact {
  id: number;
  companyNameTh: string;
  addressTh: string;
  phone: string;
  phoneSecondary: string;
  email: string;
  noteTh: string;
  isActive: boolean;
}

export function mapManualContact(raw: any): ManualContact {
  return {
    id: Number(raw?.id ?? raw?.Id ?? 0),
    companyNameTh: String(raw?.companyNameTh ?? raw?.CompanyNameTh ?? 'City Parking'),
    addressTh: String(raw?.addressTh ?? raw?.AddressTh ?? ''),
    phone: String(raw?.phone ?? raw?.Phone ?? ''),
    phoneSecondary: String(raw?.phoneSecondary ?? raw?.PhoneSecondary ?? ''),
    email: String(raw?.email ?? raw?.Email ?? ''),
    noteTh: String(raw?.noteTh ?? raw?.NoteTh ?? ''),
    isActive: Boolean(raw?.isActive ?? raw?.IsActive ?? true),
  };
}
